import React from 'react';
import classnames from 'classnames';
import Icon from '@ant-design/icons';
import useMedia from '@/Hooks/useMedia';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import { MenuItemProps } from '../Constants';

interface Props {
  selectedSection: string;
  menuList: Array<MenuItemProps>;
}

const MyhubMenu: React.FC<Props> = ({ selectedSection, menuList }) => {
  const { isMediaM } = useMedia();
  const history = useHistory();

  const onClickHandler = (link: string) => {
    if (link.includes(selectedSection)) return;
    history.replace(link);
  };

  return (
    <div role="menu" className={styles.menuContainer}>
      {menuList.map((menuItem, index) => {
        return (
          <div
            role="menuitem"
            tabIndex={index}
            key={menuItem.value}
            className={classnames(styles.menuItem, {
              [styles.active]: menuItem.link.includes(selectedSection),
            })}
            onClick={() => onClickHandler(menuItem.link)}
            onKeyPress={() => onClickHandler(menuItem.link)}
          >
            {isMediaM && <Icon component={menuItem.icon} />}
            <span>{menuItem.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MyhubMenu;
